import React, { useState, useEffect, useCallback } from 'react'

// Partials
import Btn from 'views/shared/partials/btn'
import Loader from 'views/shared/partials/loader'

// Utils
import { openModal } from 'utils/modals';

// Sections
import Breadcrumbs from 'views/admin/sections/breadcrumbs'
import AccountList from 'views/admin/sections/account-list'

// Services
import companyServices from 'services/company'

const GroupDetail = (props) => {
	const groupID = props.match.params.id;
	const defaultAccountQuery = {
		page: 1,
		sort_by: 'created_at',
		search_value: '',
		store_code: groupID,
	}

	const [data, setData] = useState(false);
	const [accountQuery, setAccountQuery] = useState(defaultAccountQuery)

	const getData = useCallback(() => {
		setData(false);
		companyServices.getGroup(groupID).then((payload) => {
			setData(payload);
		});

		// getInstallmentOptions(groupID);
	}, [groupID]);

	const searchAccounts = (newQuery) => {
		setAccountQuery({...defaultAccountQuery, ...newQuery});
	}

	const paginateAccounts = (page) => {
		searchAccounts({...accountQuery, page: page});
	}

	useEffect(() => {
		getData();
	}, [groupID, getData])

	return (
		<main className="page company-payment-type-detail">
			<Breadcrumbs
				midSections={[
					{href: 'settings.groups'}
				]} />
			<section className="portlet section detail-info loader-container">
				<Loader loading={!data} />
				{data &&
					<React.Fragment>
						<div className="portlet-header">
							<h1 className="portlet-title">{data.name} <span className="title-subtitle">#{data.store_code}</span></h1>

							<div className="header-controls">
								<Btn
									white small wide
									onClick={() => { openModal('group', { groupID: data.store_code, onSuccess: getData }); }}
									icon="edit">
									Bilgileri Düzenle
								</Btn>
								<Btn
									white small wide
									onClick={() => { openModal('company-payment-type-order', { groupID: data.store_code, onSuccess: getData }); }}
									icon="settings">
									Ödeme Ayarları
								</Btn>
								<Btn
									white small wide
									tag="link"
									href="orders"
									params={{ query: 'store_code='+data.store_code }}
									icon="card">
									Ödeme Talepleri
								</Btn>
							</div>
						</div>

						<div className="portlet-section">
							<div className="portlet-infobar">
								<div className="grid-container">
									<div className="row">
										<div className="col x3">
											<div className="infobar-section">
												<strong className="section-title">Açık Siparişler</strong>
												<span className="section-data">
													{data.order_count_active}
												</span>
											</div>
										</div>
										<div className="col x3">
											<div className="infobar-section">
												<strong className="section-title">Tamamlanmış Siparişler</strong>
												<span className="section-data">
													{data.order_count_done}
												</span>
											</div>
										</div>
										<div className="col x3">
											<div className="infobar-section">
												<strong className="section-title">IBAN</strong>
												<span className="section-data">
													{data.iban ? data.iban : '-'}
												</span>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="portlet-section bottom border-top">
							<div className="portlet-infobar horizontal">

								<div className="grid-container">
									<strong className="infobar-title">Grup Bilgileri</strong>
									<div className="row">
										<div className="col x6">
											<div className="infobar-section">
												<strong className="section-title">Grup Kodu</strong>
												<span className="section-data">
													{data.store_code ? data.store_code : '-'}
												</span>
											</div>

											<div className="infobar-section">
												<strong className="section-title">E-Posta</strong>
												<span className="section-data">
													{data.email ? data.email : '-'}
												</span>
											</div>

											<div className="infobar-section">
												<strong className="section-title">Fatura Adı</strong>
												<span className="section-data">
													{data.invoice_name ? data.invoice_name : '-'}
												</span>
											</div>

											{(data.latitude || data.longitude) &&
												<div className="infobar-section">
													<strong className="section-title">Konum</strong>
													<span className="section-data">
														{data.latitude + ', ' + data.longitude}
													</span>
												</div>
											}
										</div>
										<div className="col x6">
											<div className="infobar-section">
												<strong className="section-title">Vergi Dairesi</strong>
												<span className="section-data">
													{data.tax_office ? data.tax_office : '-'}
												</span>
											</div>											

											<div className="infobar-section">
												<strong className="section-title">Vergi Numarası</strong>
												<span className="section-data">
													{data.tax_number ? data.tax_number : '-'}
												</span>
											</div>											

											<div className="infobar-section">
												<strong className="section-title">Fatura Adresi</strong>
												<span className="section-data">
													{data.invoice_address ? data.invoice_address : '-'}
												</span>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</React.Fragment>
				}
			</section>

			{data &&
				<AccountList
					groupID={groupID}
					onSearch={searchAccounts}
					onPaginate={paginateAccounts}
					query={accountQuery} />
			}
		</main>
	)
}

export default GroupDetail